module.exports = __webpack_public_path__ + "img/logo-large-payscript.696acecd.png";